import { render, staticRenderFns } from "./finger-print-authorization.vue?vue&type=template&id=b9361152&"
import script from "./finger-print-authorization.vue?vue&type=script&lang=js&"
export * from "./finger-print-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports